//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/SelectPointList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AnalyzeMeshQuality",1,0],[0,"ModeOptions",1,0],[0,"NeighborhoodSize",1,0],[0,"PointFile",1,0],[1,"SelectPoints",0,"SelectPointList",0],[0,"SmoothingFactor",1,0],[0,"SourceOptions",1,0],[0,"TargetVertexNumber",1,0],[0,"TessellationPercentage",1,0]],[[[],"SuggestNeighborhoodSize",{},0,0]],[]];
SPLM.Facet.MeshFromCloudBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.MeshFromCloudBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.MeshFromCloudBuilder.SourceOption = Object.freeze({
    "FromFile" : "FromFile", "ExistingPoints" : "ExistingPoints"});

SPLM.Facet.MeshFromCloudBuilder.ModeOption = Object.freeze({
    "UniformDensity" : "UniformDensity", "VariableDensity" : "VariableDensity", "KeepAllPoints" : "KeepAllPoints"});

export default SPLM;